export enum eFileUploadCategories {
    securityDepositDispositionCharges = 'sddCharges',
    rentersInsurancePolicy = 'Renters Insurance Policy',
    propertyInspection = 'Inspections',
    propertyGroupAttachments = 'Property Group Attachments',
    propertyHoa = 'HOA',
    propertyTaxes = 'Taxes',
    propertyNotice = 'Notices',
    propertyManagementAgreement = 'Property Management Agreement',
    PropertyInsurance = 'Insurance',
    rentalRegistration = 'Rental Registration',
    vendorAttachment = 'Vendor',
    recurringMaintenance = 'Recurring Maintenance',
    photo = 'Photo',
    leaseAgreement = 'Lease Agreement',
    w9File = 'w-9',
    ownerAttachments = 'Attachments',
    customerSuccess = 'Customer Success'
  }
  
  export enum eNotesWriterTypes {
    owner = 'Owner',
    acm = 'ACM',
  }
  
  export enum eNotesVisibility {
    internal = 'internal',
    external = 'external',
  }
  
  export enum EUserPermission {
    SUPER_ADMIN = 1,
    ADMIN = 2,
    TEAMEATE = 3
  }

  export enum eHome365NotesEntities {
    delinquency = 'DelinquentProperty',
    project = 'project',
    property = 'property',
    vacancyNote = 'VacantProperty',
    propertyGroup = 'propertyGroup',
    tenant = 'tenant',
    owner = 'owner',
    assetsOnboarding = 'assetOnboarding',
    collection = 'collection',
    rentGuarantee = 'Rent Guarantee',
    vacancyActivity = 'vacancyActivity'
  }

  export enum eTaskPriorityText {
    high = 'High',
    medium = 'Medium',
    low = 'Low',
    overdue = 'OverDue',
    blocked = 'Blocked'
  }
  
  export enum eTaskPriority {
    high = 'HIGH',
    medium = 'MEDIUM',
    low = 'LOW',
    overDue = 'OVERDUE'
  }
  
  export enum eTicketStatus {
    open = "OPEN",
    completed = "COMPLETED",
    in_progress = "IN_PROGRESS",
    canceled = "CANCELED",
    blocked = "BLOCKED",
    closed = "CLOSED",
    skipped = "SKIPPED",
    archive = "ARCHIVE"
  }
  
  export enum eTicketStatusToClient {
    OPEN = "Open",
    COMPLETED = "Completed",
    IN_PROGRESS = "In-progress",
    CANCELED = "Canceled",
    BLOCKED = "Blocked",
    CLOSED = "Closed"
  }


export enum EUserMode {
    PROPERTY_MANAGEMENT = 1,
    PRO = 2,
    INVRSTOR = 3,
    TENANT = 4,
    CONTACT_PERSON = 5,
    APPLICANT = 6,
    CANDIDATE = 7
}

export enum eHome365DisplayFile {
    img = 1,
    video = 2,
    pdf = 3,
  }
